export const prepCardNames = [
  'Исполнители (младшая\u00A0группа)',
  'Исполнители (старшая\u00A0группа)',
  'Музыковеды (младшая\u00A0группа)',
  'Музыковеды (старшая\u00A0группа)',
];
